module.exports = (__webpack_require__(3))(3);


//////////////////
// WEBPACK FOOTER
// delegated ./src/rest.js from dll-reference girder_plugin_large_image_annotation
// module id = 1
// module chunks = 0